<template>
  <div>
    <b-container style="margin-top: 8px">
      <template v-if="status === 'loading' || status === ''">
        Loading
      </template>
      <template v-else-if="status === 'loaded'">
        <template v-if="excuses.length !== 0">
          <h3>Entschuldigungen Stand {{ (new Date).toLocaleDateString('de-DE', dateOptions) }}</h3>
          <b-table :items="excuses" :fields="fields">

            <template v-slot:table-colgroup="scope">
              <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.key === 'class' ? '40%' : 'auto' }"
              >
            </template>

            <template v-slot:cell(class)="data">
              {{ data.item.grade }} {{ data.item.grade_specification.toUpperCase() }}
            </template>

            <template v-slot:cell(name)="data">
              <b>{{ data.item.child_name }}</b>
            </template>

            <template v-slot:cell(end)="data">
              <div v-if="data.item.end">{{ new Date(data.item.end).toLocaleDateString('de-DE', dateOptions) }}</div>
              <div v-else>Heute</div>
            </template>
          </b-table>

          <b-button @click="startPrint" variant="outline-success" block class="print-button">Drucken</b-button>
        </template>

        <template v-else>
          <div style="display: flex; justify-content: space-between; align-items: center">
            <h1>Keine Entschuldigungen für heute.</h1>
          </div>
        </template>
      </template>
      <template v-else>
        Error
      </template>
      <b-button variant="outline-danger" to="/Entschuldigungen" block class="print-button mt-3">Abbrechen</b-button>
    </b-container>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import router from '@/router'

export default {
  name: 'ExcusePrintView',
  data() {
    return {
      fields: [
        {
          key: 'class',
          label: 'Klasse'
        },
        {
          key: 'name',
          label: 'Name'
        },
        {
          key: 'end',
          label: 'Bis voraussichtlich'
        }
      ],
      dateOptions: {year: 'numeric', month: '2-digit', day: '2-digit'}
    }
  },
  computed: {
    ...mapGetters([
      'getStoredExcusesToday',
      'getExcusesTodayStatus'
    ]),
    excuses() {
      return this.getStoredExcusesToday
    },
    status() {
      return this.getExcusesTodayStatus
    }
  },
  mounted() {
    this.getExcusesForToday()
  },
  methods: {
    ...mapActions([
      'getExcusesForToday',
    ]),
    startPrint() {
      window.onafterprint = () => {
        router.push('/Entschuldigungen')
      }
      window.print()
    }
  }
}
</script>

<style scoped>
.print-button {
  margin-right: 10px;
  height: 40px;
}

@media print {
  .print-button {
    display: none;
  }
}
</style>
